import {TicketType} from '../../../../graphql/generated/types';
import {getTicketName} from './getTicketName';

export function getTicketNameForLogging(ticketType: TicketType): string {
  return getTicketName(ticketType).replace(/\s+/g, '');
}
